import { styled } from "@mui/material";

export const RightSection = styled('section')(({ theme }) => (props) => ({
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.down('lg')]: {
        width: '60%'
    },
    [theme.breakpoints.down('md')]: {
        width: '100%'
    }
}))
export const ChatPart = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    flexDirection: 'column',
    gap: '4px',
    display: 'flex',
    borderRadius: '10px',
    border: `2px solid ${theme.palette.primary.main}`,
    height: '420px',
    maxHeight: '450px',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '15px 24px'
}))
export const ChatMsg = styled('div')(({ theme }) => (props) => ({
    width: 'fit-content',
    flexDirection: 'column',
    display: 'flex',
    gap: '4px',
    maxWidth: '400pt',
    borderRadius: '5px',
    flexWrap: "wrap",
    padding: ' 0 15px 16px',
    backgroundColor: props.type === "sup" ? '#F2F2F2' : '#0056D240',
    alignSelf: props.type === "sup" ? 'end' : 'start',
    margin: props.type === "sup" ? '10px 0' : ''
}))
export const MsgText = styled('p')(({ theme }) => (props) => ({
    fontWeight: '400',
    color: theme.palette.text.light,
    fontSize: '14px',
    margin: ' 12px 0 0  0'
}))
export const MsgTime = styled('p')(({ theme }) => (props) => ({
    fontWeight: '400',
    color: theme.palette.secondary.main,
    alignSelf: 'end',
    fontSize: '12px',
    margin: '0'

}))
export const MsgImage = styled('div')(({ theme }) => (props) => ({

}))
export const Image = styled('img')(({ theme }) => (props) => ({
    maxWidth: '258px',
    maxHeight: '154px'
}))
